<template>
  <div class="h-[72px] md:h-20" />
</template>
